import { useQueryParams, useMagazineContext } from 'src/hooks'

const PAGE_KEY = 'page'
const DEFAULT_VALUE_PAGE = 0

export const usePaginationFromUrl = (): number => {
  const query = useQueryParams()
  const magazine = useMagazineContext()
  const pageFromUrl = query.get(PAGE_KEY) || query.get(PAGE_KEY.toUpperCase())

  if (!pageFromUrl) {
    return DEFAULT_VALUE_PAGE
  }

  const parsed = Number.parseInt(pageFromUrl) - 1

  if (Number.isNaN(parsed) || !Number.isInteger(parsed) || parsed < 0) {
    return DEFAULT_VALUE_PAGE
  }

  if (magazine?.totalPages && parsed > magazine.totalPages) {
    return DEFAULT_VALUE_PAGE
  }
  return parsed
}
